import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import FileUpload from '../../Components/FileUpload/FileUpload'; 
import { postDataFile } from '../../Services/apiService'; 
const CreateDocuments = () => {
  const userType = 'admin';
  const [selectedFile, setSelectedFile] = useState(null);


  const navigate = useNavigate();

  const handleFileChange = (file) => {<source />
    if (file) {
      setSelectedFile(file);
    }
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error('Por favor selecciona un archivo', { position: "top-center", theme: "dark" });
      return;
    }
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    const formData = new FormData();
    const maxFileNameLength = 45;
    const fileNameWithoutExtension = selectedFile.name.substring(0, selectedFile.name.lastIndexOf('.'));
    const fileExtension = selectedFile.name.substring(selectedFile.name.lastIndexOf('.'));
    const truncatedFileName = fileNameWithoutExtension.length > maxFileNameLength 
      ? fileNameWithoutExtension.substring(0, maxFileNameLength) + fileExtension
      : selectedFile.name;
    formData.append("File", selectedFile); 
    formData.append("IdUploaderUser", idUser); 
    formData.append("UserFileName", truncatedFileName); 

    try {
      const response = await postDataFile("File/UploadFile", formData); 
      if (response.succes) {
        localStorage.setItem('toastMessage', 'Archivo subido correctamente');
        window.location.href = '/AdminDocuments';
      } else {
        toast.error('Error al subir el archivo', { position: "top-center", theme: "dark" });
      }
    } catch (error) {
      console.error("Error al subir archivo:", error);
      toast.error('No se pudo subir el archivo', { position: "top-center", theme: "dark" });
    }
  };

  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
        <UserMenu userType="admin" />
        <ToastContainer />

        {/* File Upload Section */}
        <div className="row centered">
          <div className="col-8">
            <div className="card -raspberry">
              <div className="row">
                <div className="col-12">
                  <p className="h2">Subir documentos</p>
                </div>
              </div>
              {/* Reemplaza el input por el componente FileUpload */}
              <FileUpload onFileChange={handleFileChange} />
              <div className="row justify-content-center mt-40">
                <div className="col-12 col-md-6 col-lg-4">
                  <button className="btn -secondary" onClick={handleGoBack}>Cancelar</button>
                </div>
                <div className="col-12 col-md-6 col-lg-4 mt-md-24">
                  <button className="btn -primary" onClick={handleUpload}>Subir documento</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End File Upload Section */}
      </div>
    </div>
  );
};

export default CreateDocuments;
